function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2579",
  "data-name": "Group 2579",
  transform: "translate(-220.877 -45.554)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3685",
  "data-name": "Path 3685",
  d: "M258.6,103.12a11.543,11.543,0,0,1-4.955,1.482,11.063,11.063,0,0,1-4.955-1.48l.864-1.15a2.707,2.707,0,0,1,1.354-.983,2.441,2.441,0,0,1,.545-.1c1.086-.086,1.336.342,2.216.355s1.125-.421,2.214-.314a2.416,2.416,0,0,1,.678.156,2.734,2.734,0,0,1,1.156.89Z",
  transform: "translate(-5.358 -10.936)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3686",
  "data-name": "Path 3686",
  d: "M250.721,108.348l.818.633a3.554,3.554,0,0,0,1.33.379c.1.009.195.012.293.012h1.865a3.353,3.353,0,0,0,.546-.044,3.5,3.5,0,0,0,1.259-.45l.5-.4",
  transform: "translate(-5.775 -12.465)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3687",
  "data-name": "Path 3687",
  d: "M256.935,92.938c-.076.324-.318.394-1.263,1.051a3.463,3.463,0,0,1-3.548,0c-.945-.656-1.187-.727-1.263-1.051",
  transform: "translate(-5.804 -9.31)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2577",
  "data-name": "Group 2577",
  transform: "translate(231.983 73.23)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3688",
  "data-name": "Path 3688",
  d: "M234.42,80.365a2.407,2.407,0,0,1,2.964.016,5.769,5.769,0,0,0,2.468,1.262,6.017,6.017,0,0,0,1.944.1,14.262,14.262,0,0,0,2.557-.613c.6-.17,1.11-.315,1.479-.421",
  transform: "translate(-234.42 -79.862)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3689",
  "data-name": "Path 3689",
  d: "M238.325,83.146a2.311,2.311,0,0,1,1.817-1.228",
  transform: "translate(-235.22 -80.283)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2578",
  "data-name": "Group 2578",
  transform: "translate(252.662 73.23)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3690",
  "data-name": "Path 3690",
  d: "M271.834,80.365a2.407,2.407,0,0,0-2.964.016,5.769,5.769,0,0,1-2.468,1.262,6.017,6.017,0,0,1-1.944.1,14.263,14.263,0,0,1-2.557-.613c-.6-.17-1.11-.315-1.479-.421",
  transform: "translate(-260.423 -79.862)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3691",
  "data-name": "Path 3691",
  d: "M268.583,81.918a2.311,2.311,0,0,1,1.816,1.228",
  transform: "translate(-262.094 -80.283)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3692",
  "data-name": "Path 3692",
  d: "M229.96,87.7a57.346,57.346,0,0,1-1.966-15.351,39.752,39.752,0,0,1,2.729-6.139,32.71,32.71,0,0,1,9.064-10.952,29.587,29.587,0,0,1,6.1-3.54",
  transform: "translate(-1.12 -0.871)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3693",
  "data-name": "Path 3693",
  d: "M273.376,86.692a56.763,56.763,0,0,0,1.683-15.274c-.289-.679-.718-1.662-1.273-2.829-4.628-9.74-11.99-17.483-22.289-21.121",
  transform: "translate(-5.934 0)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3694",
  "data-name": "Path 3694",
  d: "M246.2,72.944a6.285,6.285,0,0,0-3.76-2,20.572,20.572,0,0,0-5.89,0",
  transform: "translate(-2.874 -4.76)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3695",
  "data-name": "Path 3695",
  d: "M258.769,72.908a6.286,6.286,0,0,1,3.759-2,20.6,20.6,0,0,1,5.89,0",
  transform: "translate(-7.423 -4.753)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3696",
  "data-name": "Path 3696",
  d: "M226.874,75.445s-4.057-5.562-4.358-8.622",
  transform: "translate(0 -3.963)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3697",
  "data-name": "Path 3697",
  d: "M281.213,75.445s4.057-5.562,4.358-8.622",
  transform: "translate(-12.018 -3.963)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3698",
  "data-name": "Path 3698",
  d: "M270.27,81.605c0,17.841-11.793,32.305-21.137,32.305C241.666,113.91,228,99.446,228,81.605",
  transform: "translate(-1.122 -6.99)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3699",
  "data-name": "Path 3699",
  d: "M258.8,84.27a8.5,8.5,0,0,0,13.91.147,5.012,5.012,0,0,0,.678-2.5",
  transform: "translate(-7.429 -7.054)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.677
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3700",
  "data-name": "Path 3700",
  d: "M247.01,84.27a8.5,8.5,0,0,1-13.909.147,5,5,0,0,1-.678-2.5",
  transform: "translate(-2.029 -7.054)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.677
}));

var SvgDarkcirclesIcon = function SvgDarkcirclesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54.316,
    height: 62.867,
    viewBox: "0 0 54.316 62.867",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarkcirclesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/darkcircles-icon.c7ac144b.svg";
export { ForwardRef as ReactComponent };